import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TOPICS_TREE_MODE, TopicsTreeMode } from '../topics-tree-mode';
import {
  AssetTreeBadgeType,
  AssetTreeSortType,
  TOPICS_TREE_MODE_TO_DEFAULT_BADGE_TYPE,
} from './asset-tree-toolbar/asset-tree-toolbar.model';

export const provideAssetTreeSettings = () => ({
  provide: AssetTreeSettingsService,
  useClass: AssetTreeSettingsService,
});

@Injectable()
export class AssetTreeSettingsService {
  constructor(@Inject(TOPICS_TREE_MODE) private readonly topicsTreeMode: TopicsTreeMode) {}

  private readonly badgeType$$ = new BehaviorSubject<AssetTreeBadgeType | null>(
    TOPICS_TREE_MODE_TO_DEFAULT_BADGE_TYPE[this.topicsTreeMode],
  );
  private readonly sortType$$ = new BehaviorSubject<AssetTreeSortType>(AssetTreeSortType.Default);

  public readonly badgeType$ = this.badgeType$$.asObservable();
  public readonly sortType$ = this.sortType$$.asObservable();

  setBadgeType(value: AssetTreeBadgeType) {
    this.badgeType$$.next(value);
  }

  setSortType(value: AssetTreeSortType) {
    this.sortType$$.next(value);
  }
}
